module.exports = __webpack_public_path__ + "static/img/jlt.9a2852a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/itemImgs/jlt.jpg
// module id = T+mQ
// module chunks = 0